import React, { useState } from "react";
import "./Register.css";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE } from '../../config/api';

export default function Register() {
  const [credentials, setCredentials] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validate = () => {
    const errs = {};

    if (!credentials.name.trim()) {
      errs.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(credentials.name)) {
      errs.name = "Name must contain only letters and spaces";
    } else if (credentials.name.trim().length < 4) {
      errs.name = "Name must be at least 4 characters";
    }

    if (!credentials.username.trim()) {
      errs.username = "Username is required";
    } else if (credentials.username.trim().length < 3) {
      errs.username = "Username must be at least 3 characters";
    }

    if (!credentials.email.trim()) {
      errs.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(credentials.email.trim())) {
      errs.email = "Invalid email format";
    }

    if (!credentials.password) {
      errs.password = "Password is required";
    } else if (
      !/(?=.*[A-Z])/.test(credentials.password) ||
      !/(?=.*\d)/.test(credentials.password) ||
      !/(?=.*[!@#$%^&*])/.test(credentials.password) ||
      credentials.password.length < 6
    ) {
      errs.password =
        "Password must be at least 6 characters and include 1 uppercase, 1 number, and 1 symbol";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await fetch(`${API_BASE}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
      });

      if (response.ok) {
        navigate("/login");
      } else {
        const errData = await response.json();
        if (errData.message === "Username already taken") {
          setErrors({ username: errData.message });
        } else if (errData.message === "User with this email already exists") {
          setErrors({ email: errData.message });
        } else if (errData.message === "Please provide all required fields") {
          setErrors({ server: errData.message });
        } else {
          setErrors({ server: errData.message || "Registration failed" });
        }
      }
    } catch (error) {
      setErrors({ server: "Server error. Please try again later." });
      console.error("Error:", error);
    }
  };

  return (
    <div className="Register-container">
      <form className="Register-form" onSubmit={handleSubmit} noValidate>
        <h2>Register</h2>

        {errors.server && <p className="error server-error">{errors.server}</p>}

        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          placeholder="Name"
          value={credentials.name}
          onChange={handleChange}
          required
        />
        <p className="error">{errors.name || "\u00A0"}</p>

        <label htmlFor="username">Username</label>
        <input
          type="text"
          id="username"
          placeholder="Username"
          value={credentials.username}
          onChange={handleChange}
          required
        />
        <p className="error">{errors.username || "\u00A0"}</p>

        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          placeholder="Email"
          value={credentials.email}
          onChange={handleChange}
          required
        />
        <p className="error">{errors.email || "\u00A0"}</p>

        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          placeholder="Password"
          value={credentials.password}
          onChange={handleChange}
          required
        />
        <p className="error-pass">{errors.password || "\u00A0"}</p>

        <button type="submit">Register</button>

        <p className="form-footer">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </form>
    </div>
  );
}
